import { render, staticRenderFns } from "./_slugOld.vue?vue&type=template&id=b8b05086"
import script from "./_slugOld.vue?vue&type=script&lang=js"
export * from "./_slugOld.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports